
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
       <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              label-for="basicInput"
            >
            <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.name"
                :plaintext="readOnly"
                placeholder="Nom"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Prix mensuel"
              label-for="Prix"
            >
            <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
              required
                id="Prix"
                v-model="form.price"
                :state="errors.length > 0 ? false:null"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Prix"
              />
               <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nombre de devices inclus"
              label-for="DevicesNumber"
            >
            <validation-provider
              #default="{ errors }"
              name="DevicesNumber"
              rules="required"
            >
              <b-form-input
                required
                id="DevicesNumber"
                v-model="form.devices_number"
                :plaintext="readOnly"
                type="number"
                step="1"
                placeholder="Nombre de devices"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Prix par device supplémentaire"
              label-for="DevicePrice"
            >
            <validation-provider
              #default="{ errors }"
              name="DevicePrice"
              rules="required"
            >
              <b-form-input
              required
                id="DevicePrice"
                v-model="form.device_price"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Prix du device"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      </validation-observer>

    </b-card>

    <b-card
      title="Éléments d'abonnement"
      class="mt-2"
    >
      <validation-observer ref="elementsRules">
        <b-row
          v-for="(element, index) in form.subscription_elements"
          :key="index"
          class="mb-2"
        >
          <b-col
            md="4"
            xl="3"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              :label-for="`name-${index}`"
            >
              <validation-provider
                #default="{ errors }"
                :name="`Nom ${index + 1}`"
                rules="required"
              >
                <b-form-input
                  :id="`name-${index}`"
                  v-model="element.name"
                  :plaintext="readOnly"
                  placeholder="Nom"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        
          
          <b-col
            md="4"
            xl="3"
            class="mb-1"
          >
            <b-form-group
              label="Quota"
              :label-for="`quota-${index}`"
            >
              <validation-provider
                #default="{ errors }"
                :name="`Quota ${index + 1}`"
                rules="required"
              >
                <b-form-input
                  :id="`quota-${index}`"
                  v-model="element.quota"
                  :plaintext="readOnly"
                  type="number"
                  step="1"
                  placeholder="Quota"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="4"
            xl="3"
            class="mb-1"
          >
            <b-form-group
              label="Amount"
              :label-for="`amount-${index}`"
            >
              <validation-provider
                #default="{ errors }"
                :name="`Amount ${index + 1}`"
                rules="required"
              >
                <b-form-input
                  :id="`amount-${index}`"
                  v-model="element.amount"
                  :plaintext="readOnly"
                  type="number"
                  step="0.01"
                  placeholder="Amount"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="4"
            xl="3"
            class="mb-1"
          >
            <b-form-group
              label="Type de compteur"
              :label-for="`counter-type-${index}`"
            >
              
                <b-form-select
                  :id="`counter-type-${index}`"
                  v-model="element.counter_type"
                  :options="counterTypeOptions"
                  :disabled="readOnly"
                 
                />
       
            </b-form-group>
          </b-col>
          <b-col
            v-if="!readOnly"
            md="12"
            xl="3"
            class="d-flex align-items-end mb-1"
          >
            <b-button
              variant="outline-danger"
              size="sm"
              @click="removeSubscriptionElement(index)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="!readOnly">
          <b-col>
            <b-button
              variant="outline-primary"
              size="sm"
              @click="addSubscriptionElement"
            >
              + Ajouter un élément
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>

       <b-button v-if="edition==false"
     @click="createSubscription"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="editSubscription"
    >
    Enregistrer
    </b-button>

  </div>
</b-overlay>
</template>

<script>
import { BButton, BFormInput, BOverlay, BForm, BRow, BCol, BFormGroup, BFormFile, BCard, BFormCheckbox, BFormTextarea, BCardText, BMedia, BImg, BFormSelect } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest} from '@simb2s/senseye-sdk'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  name: 'SubscriptionForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormFile,
    BCardText, 
    BMedia, 
    BOverlay,
    BImg,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  data() {
      return {
       
          loading:true,
          edition:false,
          form:{
            name:"",
            scan_credits:0,
            devices_number:0,
            price:0,
            scan_price:0,
            frame_drop_credits:0,
            frame_drop_price:0,
            custom_fit_credits:0,
            custom_fit_price:0,
            device_price:0,
            subscription_elements: [],
          },
          counterTypeOptions: [
            { value: 'scans', text: 'Scans' },
            { value: 'custom_fit', text: 'Custom fit' },
            { value: 'frame_drop', text: 'Frame drop' },
          ],
      }
  },
  props: ['subscription', 'readOnly'],
  methods:{
    generateEventName() {
      const existingNames = this.form.subscription_elements.map(el => el.event_name)
      let eventName
      do {
        eventName = `event_${Math.random().toString(36).substr(2, 9)}`
      } while (existingNames.includes(eventName))
      return eventName
    },
    regenerateAllEventNames() {
      this.form.subscription_elements.forEach(element => {
        element.event_name = this.generateEventName()
      })
    },
    addSubscriptionElement() {
      this.form.subscription_elements.push({
        name: '',
        event_name: this.generateEventName(),
        quota: 0,
        amount: 0,
        counter_type: null,
      })
    },
    removeSubscriptionElement(index) {
      this.form.subscription_elements.splice(index, 1)
    },
    async validateForm() {
      const [generalValid, elementsValid] = await Promise.all([
        this.$refs.simpleRules.validate(),
        this.$refs.elementsRules.validate(),
      ])
      return generalValid && elementsValid
    },
    async createSubscription()
    {
      const success = await this.validateForm()
      if (success) {
        this.loading=true
        try {
          
          await APIRequest.create('subscription-types',this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'L\'abonnement a bien été créé !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'subscriptions'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
      }
      
    },
     async editSubscription()
    {
      const success = await this.validateForm()
      if (success) {
        this.regenerateAllEventNames()
        this.loading=true
        try {
          
          await APIRequest.update('subscription-types',this.subscription.id,this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'L\'abonnement a bien été modifié !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'subscriptions'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
      }
      
    },
   
     
      
  },
  async mounted(){
   if(this.subscription!=null)
    {
      this.form = { ...this.subscription }
      if (!this.form.subscription_elements) {
        this.form.subscription_elements = []
      }
      this.regenerateAllEventNames()
      this.edition=true
    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>